
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const InstallationRole = {
  member: 'member',
  admin: 'admin',
  viewer: 'viewer'
} as const

export type InstallationRole = (typeof InstallationRole)[keyof typeof InstallationRole]


export const InstallationMemberWorkEmailSource = {
  manual: 'manual',
  github_scim: 'github_scim',
  github_saml: 'github_saml'
} as const

export type InstallationMemberWorkEmailSource = (typeof InstallationMemberWorkEmailSource)[keyof typeof InstallationMemberWorkEmailSource]


export const BillingProvider = {
  stripe: 'stripe',
  vercel: 'vercel'
} as const

export type BillingProvider = (typeof BillingProvider)[keyof typeof BillingProvider]


export const FlexCapacityPurchaseStatus = {
  paid: 'paid',
  requires_payment: 'requires_payment',
  requires_action: 'requires_action',
  payment_failed: 'payment_failed',
  retryable: 'retryable'
} as const

export type FlexCapacityPurchaseStatus = (typeof FlexCapacityPurchaseStatus)[keyof typeof FlexCapacityPurchaseStatus]


export const FlexCapacityPaymentState = {
  requires_payment: 'requires_payment',
  requires_action: 'requires_action',
  processing: 'processing'
} as const

export type FlexCapacityPaymentState = (typeof FlexCapacityPaymentState)[keyof typeof FlexCapacityPaymentState]


export const ReviewBlockedByTopUpPaymentStatus = {
  needs_payment: 'needs_payment',
  dispatched: 'dispatched',
  skipped: 'skipped',
  dispatch_failed: 'dispatch_failed'
} as const

export type ReviewBlockedByTopUpPaymentStatus = (typeof ReviewBlockedByTopUpPaymentStatus)[keyof typeof ReviewBlockedByTopUpPaymentStatus]


export const VercelResourceStatus = {
  pending: 'pending',
  onboarding: 'onboarding',
  ready: 'ready',
  suspended: 'suspended',
  resumed: 'resumed',
  uninstalled: 'uninstalled',
  error: 'error'
} as const

export type VercelResourceStatus = (typeof VercelResourceStatus)[keyof typeof VercelResourceStatus]


export const VercelInvoiceCurrency = {
  usd: 'usd'
} as const

export type VercelInvoiceCurrency = (typeof VercelInvoiceCurrency)[keyof typeof VercelInvoiceCurrency]


export const VercelInvoiceStatus = {
  draft: 'draft',
  pending: 'pending',
  scheduled: 'scheduled',
  invoiced: 'invoiced',
  paid: 'paid',
  notpaid: 'notpaid',
  refund_requested: 'refund_requested',
  refunded: 'refunded'
} as const

export type VercelInvoiceStatus = (typeof VercelInvoiceStatus)[keyof typeof VercelInvoiceStatus]


export const CriticalIssueStatus = {
  Pending: 'Pending',
  Fixed: 'Fixed'
} as const

export type CriticalIssueStatus = (typeof CriticalIssueStatus)[keyof typeof CriticalIssueStatus]


export const RepoLearningRunStatus = {
  started: 'started',
  no_reviewers: 'no_reviewers',
  below_threshold: 'below_threshold',
  analysis_skipped: 'analysis_skipped',
  llm_error: 'llm_error',
  success: 'success',
  skipped_below_threshold: 'skipped_below_threshold',
  error: 'error'
} as const

export type RepoLearningRunStatus = (typeof RepoLearningRunStatus)[keyof typeof RepoLearningRunStatus]


export const LearningReflectionRunStatus = {
  started: 'started',
  success: 'success',
  skipped_below_threshold: 'skipped_below_threshold',
  error: 'error'
} as const

export type LearningReflectionRunStatus = (typeof LearningReflectionRunStatus)[keyof typeof LearningReflectionRunStatus]


export const RepositoryLearningStatus = {
  active: 'active',
  archived: 'archived',
  pending_review: 'pending_review'
} as const

export type RepositoryLearningStatus = (typeof RepositoryLearningStatus)[keyof typeof RepositoryLearningStatus]


export const WikiGenerationStatus = {
  pending: 'pending',
  generating: 'generating',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  error: 'error'
} as const

export type WikiGenerationStatus = (typeof WikiGenerationStatus)[keyof typeof WikiGenerationStatus]


export const WikiGenerationStage = {
  starting: 'starting',
  cloning: 'cloning',
  processing: 'processing',
  ai_structure: 'ai_structure',
  parsing: 'parsing',
  pages: 'pages',
  page_generation: 'page_generation',
  saving: 'saving',
  completed: 'completed',
  error: 'error'
} as const

export type WikiGenerationStage = (typeof WikiGenerationStage)[keyof typeof WikiGenerationStage]


export const WikiRepoSyncRunStatus = {
  pending: 'pending',
  no_changes: 'no_changes',
  pr_opened: 'pr_opened',
  pr_updated: 'pr_updated',
  failed: 'failed',
  skipped: 'skipped'
} as const

export type WikiRepoSyncRunStatus = (typeof WikiRepoSyncRunStatus)[keyof typeof WikiRepoSyncRunStatus]


export const WikiPageImportance = {
  high: 'high',
  medium: 'medium',
  low: 'low'
} as const

export type WikiPageImportance = (typeof WikiPageImportance)[keyof typeof WikiPageImportance]


export const MessageRole = {
  user: 'user',
  assistant: 'assistant',
  system: 'system'
} as const

export type MessageRole = (typeof MessageRole)[keyof typeof MessageRole]


export const IssueProvider = {
  LINEAR: 'LINEAR',
  GITHUB: 'GITHUB',
  JIRA: 'JIRA',
  ASANA: 'ASANA',
  NOTION: 'NOTION',
  CONFLUENCE: 'CONFLUENCE'
} as const

export type IssueProvider = (typeof IssueProvider)[keyof typeof IssueProvider]


export const ReviewFileRunStatus = {
  processed: 'processed',
  failed: 'failed',
  skipped: 'skipped'
} as const

export type ReviewFileRunStatus = (typeof ReviewFileRunStatus)[keyof typeof ReviewFileRunStatus]


export const RepoScanViolationTriageStatus = {
  open: 'open',
  in_review: 'in_review',
  resolved: 'resolved',
  false_positive: 'false_positive',
  wont_fix: 'wont_fix',
  intended_behavior: 'intended_behavior',
  accepted_risk: 'accepted_risk'
} as const

export type RepoScanViolationTriageStatus = (typeof RepoScanViolationTriageStatus)[keyof typeof RepoScanViolationTriageStatus]


export const ReviewDiffStrategyEnum = {
  FULL: 'FULL',
  INCREMENTAL: 'INCREMENTAL'
} as const

export type ReviewDiffStrategyEnum = (typeof ReviewDiffStrategyEnum)[keyof typeof ReviewDiffStrategyEnum]


export const ReviewLineUsageBucket = {
  installation_quota: 'installation_quota',
  public_repository_fair_use: 'public_repository_fair_use'
} as const

export type ReviewLineUsageBucket = (typeof ReviewLineUsageBucket)[keyof typeof ReviewLineUsageBucket]


export const ReviewSessionStatus = {
  running: 'running',
  consolidating: 'consolidating',
  posting: 'posting',
  completed: 'completed',
  failed: 'failed',
  timed_out: 'timed_out',
  cancelled: 'cancelled',
  superseded: 'superseded'
} as const

export type ReviewSessionStatus = (typeof ReviewSessionStatus)[keyof typeof ReviewSessionStatus]


export const ReviewSessionFailureStage = {
  initiate: 'initiate',
  fetch_pr_context: 'fetch_pr_context',
  start_policy: 'start_policy',
  planning: 'planning',
  processing: 'processing',
  consolidation: 'consolidation',
  posting: 'posting',
  timeout: 'timeout',
  cancellation: 'cancellation'
} as const

export type ReviewSessionFailureStage = (typeof ReviewSessionFailureStage)[keyof typeof ReviewSessionFailureStage]


export const ReviewMode = {
  STANDARD: 'STANDARD',
  ULTRAREVIEW: 'ULTRAREVIEW'
} as const

export type ReviewMode = (typeof ReviewMode)[keyof typeof ReviewMode]


export const ReviewRoutingTier = {
  ultrareview: 'ultrareview',
  super_premium: 'super_premium',
  premium: 'premium',
  cost_optimized: 'cost_optimized',
  standard: 'standard',
  open_source: 'open_source'
} as const

export type ReviewRoutingTier = (typeof ReviewRoutingTier)[keyof typeof ReviewRoutingTier]


export const ReviewSensitivity = {
  low: 'low',
  medium: 'medium',
  high: 'high'
} as const

export type ReviewSensitivity = (typeof ReviewSensitivity)[keyof typeof ReviewSensitivity]


export const AIReviewSettingScope = {
  repository: 'repository',
  installation: 'installation'
} as const

export type AIReviewSettingScope = (typeof AIReviewSettingScope)[keyof typeof AIReviewSettingScope]


export const RepositoryVisibility = {
  public: 'public',
  private: 'private'
} as const

export type RepositoryVisibility = (typeof RepositoryVisibility)[keyof typeof RepositoryVisibility]


export const InstallationBillingStateAtEvent = {
  free: 'free',
  trialing: 'trialing',
  paid: 'paid',
  unknown: 'unknown'
} as const

export type InstallationBillingStateAtEvent = (typeof InstallationBillingStateAtEvent)[keyof typeof InstallationBillingStateAtEvent]


export const ReviewRoutingTierReason = {
  trialling: 'trialling',
  low_priority_queue: 'low_priority_queue',
  default: 'default',
  small_install_downgrade: 'small_install_downgrade',
  ultrareview_requested: 'ultrareview_requested',
  auto_ultrareview: 'auto_ultrareview',
  super_premium_allowlist: 'super_premium_allowlist',
  large_trial_install: 'large_trial_install',
  owner_allowlist: 'owner_allowlist',
  installation_allowlist: 'installation_allowlist',
  recent_paid_upgrade: 'recent_paid_upgrade',
  recent_paid_upgrade_installation_override: 'recent_paid_upgrade_installation_override',
  codex_quota: 'codex_quota',
  incremental_review_volume: 'incremental_review_volume',
  review_line_quota_incremental: 'review_line_quota_incremental',
  review_line_quota_all: 'review_line_quota_all',
  open_source: 'open_source'
} as const

export type ReviewRoutingTierReason = (typeof ReviewRoutingTierReason)[keyof typeof ReviewRoutingTierReason]


export const CustomRuleManagedBy = {
  ui: 'ui',
  yaml: 'yaml'
} as const

export type CustomRuleManagedBy = (typeof CustomRuleManagedBy)[keyof typeof CustomRuleManagedBy]


export const CustomRuleInstructionSource = {
  text: 'text',
  file_paths: 'file_paths'
} as const

export type CustomRuleInstructionSource = (typeof CustomRuleInstructionSource)[keyof typeof CustomRuleInstructionSource]


export const YamlOrigin = {
  repo_yaml: 'repo_yaml',
  org_yaml: 'org_yaml'
} as const

export type YamlOrigin = (typeof YamlOrigin)[keyof typeof YamlOrigin]


export const GroupingStrategyEnum = {
  FILE_PATTERN: 'FILE_PATTERN',
  SEMANTIC_SIMILARITY: 'SEMANTIC_SIMILARITY',
  DIRECTORY_STRUCTURE: 'DIRECTORY_STRUCTURE',
  FALLBACK: 'FALLBACK',
  SKIPPED_INCREMENTAL: 'SKIPPED_INCREMENTAL',
  SINGLE_BATCH: 'SINGLE_BATCH',
  FALLBACK_SEQUENTIAL: 'FALLBACK_SEQUENTIAL',
  SINGLE_RULE: 'SINGLE_RULE',
  UNKNOWN: 'UNKNOWN'
} as const

export type GroupingStrategyEnum = (typeof GroupingStrategyEnum)[keyof typeof GroupingStrategyEnum]


export const AutoApproveMode = {
  disabled: 'disabled',
  always: 'always',
  low_risk_only: 'low_risk_only',
  custom: 'custom'
} as const

export type AutoApproveMode = (typeof AutoApproveMode)[keyof typeof AutoApproveMode]


export const AutoApproveBehavior = {
  disabled: 'disabled',
  shadow: 'shadow',
  live: 'live'
} as const

export type AutoApproveBehavior = (typeof AutoApproveBehavior)[keyof typeof AutoApproveBehavior]


export const AutoApproveAllowedOpenIssues = {
  none: 'none',
  p3: 'p3',
  p2_and_p3: 'p2_and_p3',
  p1_to_p3: 'p1_to_p3',
  all: 'all'
} as const

export type AutoApproveAllowedOpenIssues = (typeof AutoApproveAllowedOpenIssues)[keyof typeof AutoApproveAllowedOpenIssues]


export const AutoUltrareviewMode = {
  disabled: 'disabled',
  high_risk_only: 'high_risk_only',
  custom: 'custom'
} as const

export type AutoUltrareviewMode = (typeof AutoUltrareviewMode)[keyof typeof AutoUltrareviewMode]


export const UltrareviewMode = {
  disabled: 'disabled',
  manual: 'manual',
  automatic: 'automatic'
} as const

export type UltrareviewMode = (typeof UltrareviewMode)[keyof typeof UltrareviewMode]


export const AutoApprovalGithubIdentityStatus = {
  pending_verification: 'pending_verification',
  connected: 'connected',
  invalid: 'invalid',
  revoked: 'revoked'
} as const

export type AutoApprovalGithubIdentityStatus = (typeof AutoApprovalGithubIdentityStatus)[keyof typeof AutoApprovalGithubIdentityStatus]


export const AutoFixProvider = {
  cubic: 'cubic',
  cursor_cloud_agent: 'cursor_cloud_agent'
} as const

export type AutoFixProvider = (typeof AutoFixProvider)[keyof typeof AutoFixProvider]


export const AutoFixLoopMode = {
  off: 'off',
  on_demand: 'on_demand',
  on: 'on'
} as const

export type AutoFixLoopMode = (typeof AutoFixLoopMode)[keyof typeof AutoFixLoopMode]


export const VerifyMode = {
  off: 'off',
  on: 'on'
} as const

export type VerifyMode = (typeof VerifyMode)[keyof typeof VerifyMode]


export const CursorCloudAgentKeyType = {
  api_key: 'api_key',
  service_account: 'service_account'
} as const

export type CursorCloudAgentKeyType = (typeof CursorCloudAgentKeyType)[keyof typeof CursorCloudAgentKeyType]


export const ObservabilityPlatform = {
  posthog: 'posthog',
  sentry: 'sentry',
  datadog: 'datadog'
} as const

export type ObservabilityPlatform = (typeof ObservabilityPlatform)[keyof typeof ObservabilityPlatform]


export const ScanTrigger = {
  manual: 'manual',
  scheduled: 'scheduled',
  post_merge: 'post_merge'
} as const

export type ScanTrigger = (typeof ScanTrigger)[keyof typeof ScanTrigger]


export const RepoScanSchedule = {
  daily: 'daily',
  weekly: 'weekly',
  biweekly: 'biweekly',
  monthly: 'monthly',
  quarterly: 'quarterly'
} as const

export type RepoScanSchedule = (typeof RepoScanSchedule)[keyof typeof RepoScanSchedule]


export const RepoScanBias = {
  balanced: 'balanced',
  security: 'security'
} as const

export type RepoScanBias = (typeof RepoScanBias)[keyof typeof RepoScanBias]


export const ScanScopeKind = {
  full: 'full',
  diff: 'diff',
  skip: 'skip'
} as const

export type ScanScopeKind = (typeof ScanScopeKind)[keyof typeof ScanScopeKind]


export const AutoRemediationReviewerType = {
  codeowner: 'codeowner',
  author: 'author',
  both: 'both',
  none: 'none'
} as const

export type AutoRemediationReviewerType = (typeof AutoRemediationReviewerType)[keyof typeof AutoRemediationReviewerType]


export const ConcernCategory = {
  security: 'security',
  data_integrity: 'data_integrity',
  business_logic: 'business_logic',
  stability: 'stability'
} as const

export type ConcernCategory = (typeof ConcernCategory)[keyof typeof ConcernCategory]


export const LearningUsageAttribution = {
  agent_cited: 'agent_cited',
  filter_candidate: 'filter_candidate',
  passthrough_candidate: 'passthrough_candidate',
  backfill: 'backfill',
  suppressed_negative_signal: 'suppressed_negative_signal',
  suppressed_contextual: 'suppressed_contextual'
} as const

export type LearningUsageAttribution = (typeof LearningUsageAttribution)[keyof typeof LearningUsageAttribution]


export const SuggestedRuleSource = {
  comment_history: 'comment_history',
  senior_reviewer_comments: 'senior_reviewer_comments',
  popular: 'popular'
} as const

export type SuggestedRuleSource = (typeof SuggestedRuleSource)[keyof typeof SuggestedRuleSource]


export const PrWorkType = {
  feature: 'feature',
  bug: 'bug',
  maintenance: 'maintenance',
  conflicting: 'conflicting',
  unknown: 'unknown'
} as const

export type PrWorkType = (typeof PrWorkType)[keyof typeof PrWorkType]


export const WorkClassificationStatus = {
  complete: 'complete',
  failed: 'failed'
} as const

export type WorkClassificationStatus = (typeof WorkClassificationStatus)[keyof typeof WorkClassificationStatus]


export const ReviewLeadTimeSampleSource = {
  POST_INSTALL: 'POST_INSTALL',
  PRE_INSTALL: 'PRE_INSTALL'
} as const

export type ReviewLeadTimeSampleSource = (typeof ReviewLeadTimeSampleSource)[keyof typeof ReviewLeadTimeSampleSource]


export const ReviewLeadTimeSampleStatus = {
  COMPUTED: 'COMPUTED',
  NO_HUMAN_APPROVAL: 'NO_HUMAN_APPROVAL',
  TIMELINE_UNAVAILABLE: 'TIMELINE_UNAVAILABLE',
  INVALID_LIFECYCLE: 'INVALID_LIFECYCLE'
} as const

export type ReviewLeadTimeSampleStatus = (typeof ReviewLeadTimeSampleStatus)[keyof typeof ReviewLeadTimeSampleStatus]


export const ReviewLeadTimeBaselineStatus = {
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
  INSUFFICIENT_DATA: 'INSUFFICIENT_DATA',
  UNAVAILABLE: 'UNAVAILABLE'
} as const

export type ReviewLeadTimeBaselineStatus = (typeof ReviewLeadTimeBaselineStatus)[keyof typeof ReviewLeadTimeBaselineStatus]


export const CliAuthType = {
  jwt: 'jwt',
  api_key: 'api_key'
} as const

export type CliAuthType = (typeof CliAuthType)[keyof typeof CliAuthType]


export const McpAccessLevel = {
  read: 'read',
  review: 'review',
  admin: 'admin'
} as const

export type McpAccessLevel = (typeof McpAccessLevel)[keyof typeof McpAccessLevel]


export const ApiKeyAccess = {
  read: 'read',
  admin: 'admin'
} as const

export type ApiKeyAccess = (typeof ApiKeyAccess)[keyof typeof ApiKeyAccess]


export const AiMarkerAttributionBand = {
  certain: 'certain',
  likely: 'likely',
  weak: 'weak'
} as const

export type AiMarkerAttributionBand = (typeof AiMarkerAttributionBand)[keyof typeof AiMarkerAttributionBand]


export const GitAiBugBenchRunStatus = {
  building: 'building',
  current: 'current',
  superseded: 'superseded'
} as const

export type GitAiBugBenchRunStatus = (typeof GitAiBugBenchRunStatus)[keyof typeof GitAiBugBenchRunStatus]


export const GitHubSlackMappingSource = {
  manual: 'manual',
  auto_email: 'auto_email',
  auto_name: 'auto_name',
  self_claimed: 'self_claimed'
} as const

export type GitHubSlackMappingSource = (typeof GitHubSlackMappingSource)[keyof typeof GitHubSlackMappingSource]


export const PmfSurveyAnswer = {
  VERY_DISAPPOINTED: 'VERY_DISAPPOINTED',
  SOMEWHAT_DISAPPOINTED: 'SOMEWHAT_DISAPPOINTED',
  NOT_DISAPPOINTED: 'NOT_DISAPPOINTED'
} as const

export type PmfSurveyAnswer = (typeof PmfSurveyAnswer)[keyof typeof PmfSurveyAnswer]


export const LinkedPullRequestState = {
  open: 'open',
  closed: 'closed',
  merged: 'merged',
  unknown: 'unknown'
} as const

export type LinkedPullRequestState = (typeof LinkedPullRequestState)[keyof typeof LinkedPullRequestState]


export const CodeSessionStatus = {
  creating: 'creating',
  idle: 'idle',
  running: 'running',
  stopped: 'stopped',
  failed: 'failed',
  archived: 'archived'
} as const

export type CodeSessionStatus = (typeof CodeSessionStatus)[keyof typeof CodeSessionStatus]


export const CodeSessionSource = {
  web: 'web',
  slack: 'slack',
  cubic: 'cubic',
  github: 'github',
  mcp: 'mcp',
  pr_page: 'pr_page'
} as const

export type CodeSessionSource = (typeof CodeSessionSource)[keyof typeof CodeSessionSource]


export const CodeSessionPosture = {
  same_repository: 'same_repository',
  fork: 'fork'
} as const

export type CodeSessionPosture = (typeof CodeSessionPosture)[keyof typeof CodeSessionPosture]


export const CodeSessionPurpose = {
  general: 'general',
  environment_setup: 'environment_setup',
  finding_fix: 'finding_fix'
} as const

export type CodeSessionPurpose = (typeof CodeSessionPurpose)[keyof typeof CodeSessionPurpose]


export const CodeSandboxStatus = {
  pending: 'pending',
  spawning: 'spawning',
  connecting: 'connecting',
  ready: 'ready',
  snapshotting: 'snapshotting',
  stopped: 'stopped',
  failed: 'failed',
  stale: 'stale'
} as const

export type CodeSandboxStatus = (typeof CodeSandboxStatus)[keyof typeof CodeSandboxStatus]


export const CodeTurnDelivery = {
  steer: 'steer',
  queue: 'queue'
} as const

export type CodeTurnDelivery = (typeof CodeTurnDelivery)[keyof typeof CodeTurnDelivery]


export const CodeTurnStatus = {
  queued: 'queued',
  admitted: 'admitted',
  running: 'running',
  done: 'done',
  failed: 'failed',
  interrupted: 'interrupted'
} as const

export type CodeTurnStatus = (typeof CodeTurnStatus)[keyof typeof CodeTurnStatus]


export const CodeSessionSpareState = {
  booting: 'booting',
  pooled: 'pooled',
  claimed: 'claimed',
  own_sandbox_ready: 'own_sandbox_ready',
  moved: 'moved',
  failed: 'failed',
  retired: 'retired'
} as const

export type CodeSessionSpareState = (typeof CodeSessionSpareState)[keyof typeof CodeSessionSpareState]


export const FixSessionKind = {
  auto_fix: 'auto_fix',
  fix_with_cubic: 'fix_with_cubic',
  command: 'command',
  codebase_scan: 'codebase_scan',
  auto_remediation: 'auto_remediation'
} as const

export type FixSessionKind = (typeof FixSessionKind)[keyof typeof FixSessionKind]


export const FixSessionStatus = {
  running: 'running',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled'
} as const

export type FixSessionStatus = (typeof FixSessionStatus)[keyof typeof FixSessionStatus]


export const AiSubscriptionProvider = {
  chatgpt: 'chatgpt'
} as const

export type AiSubscriptionProvider = (typeof AiSubscriptionProvider)[keyof typeof AiSubscriptionProvider]


export const AiSubscriptionConnectionStatus = {
  active: 'active',
  needs_auth: 'needs_auth'
} as const

export type AiSubscriptionConnectionStatus = (typeof AiSubscriptionConnectionStatus)[keyof typeof AiSubscriptionConnectionStatus]


export const McpServerAuthType = {
  none: 'none',
  api_key: 'api_key',
  oauth: 'oauth'
} as const

export type McpServerAuthType = (typeof McpServerAuthType)[keyof typeof McpServerAuthType]


export const McpServerOAuthRegistration = {
  dynamic: 'dynamic',
  static: 'static'
} as const

export type McpServerOAuthRegistration = (typeof McpServerOAuthRegistration)[keyof typeof McpServerOAuthRegistration]


export const McpServerUserTokenStatus = {
  active: 'active',
  needs_auth: 'needs_auth'
} as const

export type McpServerUserTokenStatus = (typeof McpServerUserTokenStatus)[keyof typeof McpServerUserTokenStatus]


export const SocialRadarPlatform = {
  hackernews: 'hackernews',
  reddit: 'reddit',
  x: 'x',
  linkedin: 'linkedin'
} as const

export type SocialRadarPlatform = (typeof SocialRadarPlatform)[keyof typeof SocialRadarPlatform]


export const SocialRadarVerdict = {
  alert: 'alert',
  skip: 'skip'
} as const

export type SocialRadarVerdict = (typeof SocialRadarVerdict)[keyof typeof SocialRadarVerdict]


export const SocialRadarPriority = {
  high: 'high',
  medium: 'medium'
} as const

export type SocialRadarPriority = (typeof SocialRadarPriority)[keyof typeof SocialRadarPriority]
